<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import type { WidgetTabs, Action } from '../types'
import { spacingClasses } from '../utils/classes'
import ACElement from './ACElement.vue'

const props = defineProps<{
  element: WidgetTabs
  onAction?: (action: Action, inputs: Record<string, string>) => void
}>()

const selectedIndex = ref(props.element.defaultTabIndex ?? 0)
const selectedTab = computed(() => props.element.tabs[selectedIndex.value])

onMounted(() => {
  // Clamp in case defaultTabIndex is out of range
  if (selectedIndex.value >= props.element.tabs.length) {
    selectedIndex.value = 0
  }
})
</script>

<template>
  <div :class="element.spacing ? spacingClasses[element.spacing] : 'mt-2'">

    <p v-if="element.headerLabel" class="mb-1 pr-1 text-right text-xs font-medium text-muted-foreground">
      {{ element.headerLabel }}
    </p>

    <!-- Tab strip -->
    <div class="flex justify-between px-1">
      <button
        v-for="(tab, i) in element.tabs"
        :key="i"
        class="flex flex-col items-center gap-0.5 rounded-full px-2 py-1.5 text-xs transition-colors"
        :class="selectedIndex === i
          ? 'bg-primary text-primary-foreground font-semibold'
          : 'text-muted-foreground hover:text-foreground'"
        @click="selectedIndex = i"
      >
        <span>{{ tab.label }}</span>
        <span v-if="tab.sublabel">{{ tab.sublabel }}</span>
      </button>
    </div>

    <!-- Tab content -->
    <div v-if="selectedTab" class="mt-3 border-t pt-3">
      <ACElement
        v-for="(item, i) in selectedTab.items"
        :key="i"
        :element="item"
        :on-action="onAction"
      />
    </div>
  </div>
</template>
